// src/js/core/translateWords.js

const STORAGE_KEY = "translationsByLanguage";

let translationsByLanguage = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

function saveTranslations() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(translationsByLanguage));
}

function getCachedTranslation(word, fromLanguage) {
  translationsByLanguage[fromLanguage] = translationsByLanguage[fromLanguage] || {};
  return translationsByLanguage[fromLanguage][word];
}

function cacheTranslation(word, fromLanguage, translationData) {
  translationsByLanguage[fromLanguage] = translationsByLanguage[fromLanguage] || {};
  translationsByLanguage[fromLanguage][word] = translationData;
  saveTranslations();
}

async function fetchTranslation(word, fromLanguage) {
  try {
    const response = await fetch("/.netlify/functions/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: word,
        fromLanguage: fromLanguage,
        isParagraph: false,
      }),
    });

    if (!response.ok) {
      throw new Error(`Translation API error: ${response.status}`);
    }

    const translationData = await response.json();
    return translationData;
  } catch (error) {
    console.error("Translation error:", error);
    return null;
  }
}

export async function getTranslation(word, fromLanguage) {
  const cached = getCachedTranslation(word, fromLanguage);
  if (cached) {
    return cached;
  }

  const translationData = await fetchTranslation(word, fromLanguage);
  if (translationData) {
    cacheTranslation(word, fromLanguage, translationData);
  }
  return translationData;
}

export function removeTranslation(word, language) {
  if (translationsByLanguage[language] && translationsByLanguage[language][word]) {
    delete translationsByLanguage[language][word];
    saveTranslations();
  }
}

export function clearTranslations(language) {
  translationsByLanguage[language] = {};
  saveTranslations();
}
